import { useMutation } from '@tanstack/react-query';
import { deleteCity } from '@/api/city';
import { GetDeleteCityData ,ReturnUpdateDelete} from "@/types";
import { PostParam } from "@/types/index";

export function useDeleteCity(props?: PostParam) {
  const { onSuccess, onError } = props || {};

  return useMutation<ReturnUpdateDelete, Error, GetDeleteCityData>({
    mutationFn: deleteCity,
    onSuccess,
    onError
  });
}
